import { render, staticRenderFns } from "./route-info-v2-route-table-header.vue?vue&type=template&id=39a9a4d4&scoped=true&"
import script from "./route-info-v2-route-table-header.vue?vue&type=script&lang=ts&"
export * from "./route-info-v2-route-table-header.vue?vue&type=script&lang=ts&"
import style0 from "./route-info-v2-route-table-header.vue?vue&type=style&index=0&id=39a9a4d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a9a4d4",
  null
  
)

export default component.exports